export default __webpack_public_path__ + "static/media/matchmaker-details.2b326a52.webp";